<div class="grid p-fluid">
	<div class="col-12" [class]="onExtendedMobile() ? 'px-0' : ''">
		<p-tabView [scrollable]="true" [activeIndex]="activeIndex" (onChange)="selectedIndexChange($event)"
			styleClass="transparent-tabView">
			<!-- AUTOMATIONS -->
			<p-tabPanel header="{{ 'LIST_DEVICE_AUTOMATIONS' | translate }}">
				<app-device-treetable class="pt-0"></app-device-treetable>
			</p-tabPanel>
			<!-- THERMO -->
			<p-tabPanel header="{{ 'LIST_DEVICE_THERMO' | translate }}">
				<app-devices-th-list></app-devices-th-list>
			</p-tabPanel>
			<!-- VCT -->
			<p-tabPanel header="{{ 'LIST_DEVICE_VCT' | translate }}" *ngIf="!isImpersMode">
				<app-devices-vct-list *ngIf="!editSystem"></app-devices-vct-list>
				<app-devices-vct-list-edit *ngIf="editSystem"></app-devices-vct-list-edit>
			</p-tabPanel>
		</p-tabView>
	</div>
</div>